import Vue from 'vue';
import VueRouter from 'vue-router';
import BetConsole from '@/views/BetConsole.vue';
import Nonautorizzato from '@/views/404.vue';
import NotAuthorized2 from '@/views/404V2.vue';
import NotAuthorized3 from '@/views/404V3.vue';
import NotAuthorized4 from '@/views/404V4.vue';
import Statistics from '@/views/Statistics.vue';
import SportPage from '@/components/IllinoisSport/pages/Sport.vue';
import HomeIllinois from '@/components/IllinoisSport/pages/Home.vue';
import TournamentPage from '@/components/IllinoisSport/pages/Tournament.vue';
import EventPage from '@/components/IllinoisSport/pages/Event.vue';
import IllinoisLive from '@/components/IllinoisSport/pages/Live.vue';
import IllinoisLiveDetails from '@/components/IllinoisSport/pages/LiveDetails.vue';
import IllinoisPrintOdds from '@/components/IllinoisSport/pages/PrintOdds.vue';
import { checkauth } from '../Helper';
import MainLayout from '@/components/IllinoisSport/layout/Main.vue';

Vue.use(VueRouter);

// Dynamic root switcher: renders BetConsole or Illinois MainLayout based on uiConfig.sportModule
const RootSwitch = {
  name: 'RootSwitch',
  render(h) {
    const fullConfig =
      (this.$store &&
        this.$store.getters &&
        this.$store.getters['uiConfig/fullUIConfig']) ||
      {};
    const sportModule = fullConfig.sportModule || 'default';
    if (sportModule === 'illinois') {
      return h(MainLayout);
    }
    return h(BetConsole);
  }
};

const routes = [
  {
    path: '/',
    name: 'IllinoisLayout',
    component: RootSwitch,
    beforeEnter(to, from, next) {
      checkauth().then(response => {
        if (!response) {
          //console.log("tescfgs")
          next('/404');
        } else {
          //console.log("home")
          next();
        }
      });
    },
    children: [
      {
        path: '',
        name: 'IllinoisHome',
        component: HomeIllinois
      },
      {
        path: 'sport/:sportId',
        name: 'IllinoisSport',
        component: SportPage,
        props: true
      },
      {
        path: 'sport/:sportId/category/:categoryId/tournament/:tournamentId',
        name: 'IllinoisTournament',
        component: TournamentPage,
        props: route => ({
          tournamentId: route.params.tournamentId,
          sportId: route.params.sportId,
          categoryId: route.params.categoryId
        })
      },
      {
        path: 'sport/:sportId/category/:categoryId/tournament/:tournamentId/event/:eventId',
        name: 'IllinoisEvent',
        component: EventPage,
        props: route => ({
          eventId: route.params.eventId,
          sportId: route.params.sportId,
          categoryId: route.params.categoryId,
          tournamentId: route.params.tournamentId
        })
      },
      {
        path: '/live',
        name: 'IllinoisLive',
        component: IllinoisLive
      },
      {
        path: 'live/:sportId/category/:categoryId/tournament/:tournamentId/event/:eventId',
        name: 'IllinoisLiveDetails',
        component: IllinoisLiveDetails,
        props: route => ({
          eventId: route.params.eventId,
          sportId: route.params.sportId,
          categoryId: route.params.categoryId,
          tournamentId: route.params.tournamentId
        })
      },
      {
        path: 'print-odds',
        name: 'IllinoisPrintOdds',
        component: IllinoisPrintOdds
      }
      /* {
        path: '/tournament/:tournamentId',
        name: 'IllinoisTournament',
        component: TournamentPage,
        props: route => ({
          tournamentId: route.params.tournamentId,
          sportId: route.query.sportId || '',
          categoryId: route.query.categoryId || ''
        })
      } */
    ]
  },
  {
    path: '/bet-console',
    name: 'BetConsole',
    component: BetConsole,
    beforeEnter(to, from, next) {
      checkauth().then(response => {
        if (!response) {
          //console.log("tescfgs")
          next('/404');
        } else {
          //console.log("home")
          next();
        }
      });
    }
  },

  {
    path: '/404',
    name: 'Nonautorizzato',
    component: Nonautorizzato
  },
  {
    path: '/statistics',
    name: 'Statistics',
    component: Statistics
  },
  {
    path: '/404V2',
    name: 'NonautorizzatoV2',
    component: NotAuthorized2
  },
  {
    path: '/404V3',
    name: 'NonautorizzatoV3',
    component: NotAuthorized3
  },
  {
    path: '/404V4',
    name: 'NonautorizzatoV4',
    component: NotAuthorized4
  }
];

const router = new VueRouter({
  mode: 'hash',
  routes
});

export default router;
